import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { Link } from 'gatsby';
import './design-guidelines-styles.css';
import { DemoModal } from '../../components/DemoModal';
import { LeadParagraph } from '../../components/LeadParagraph';
export const _frontmatter = {
  "pageTitle": "Modal Design Guidelines",
  "title": "Modal",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

<PageContent componentName="modal" type="design" mdxType="PageContent">
<LeadParagraph mdxType="LeadParagraph">
  Modals inform users about a task and can contain critical information, require
  decisions, or involve multiple tasks.
</LeadParagraph>
<p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.61776061776062%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAIAAADtbgqsAAAACXBIWXMAAAsTAAALEwEAmpwYAAABcklEQVQoz33S3W7aMBTAcZ4zXoUEOMDKDTdLeIMNTZMqlnCNEC9R9SVaJLTxtRukDGRSEcexE8fnVE1Kum50v4vIN3+dYzk1u0Ap7fV6g8HAdV3HcT69w3Gcfr9vn9Vs2+50OoSQyWQSx/FutzudTsYY/Y8sywBwPl9Q2nqNu92uZVmz2QwAwjAUQqgzWUiSRCmVJAkAbLfbVuttTAiZTqda6/1+zxg7FIIg+F0IguBwODDGEHG9Xl+OASCKImMMnJlCdUDEzWZzOTbGHI9HzrmUMitUt82yLE1TRFwul5djROScV2MRUSlV7oKIeZ7/b22tNWMsiqJycpqmQogwPHIeSZkAlPHq79iyrHKy1rq8JBYAQEqdyEyp/OfqcfNL3D/8sG164amq3f4UCxACeJx/vZl//ra4vbu//timlL7E7Xa72Wy6rjsej0ej0fe3PM/zfc/zns++7w+HX8ryJS77RqNBCPnwvqur52+9Xq9+zycIg+8xKZC45wAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": " ",
            "title": " ",
            "src": "/version/4.2.0/static/63f781efbfdefd5014fd1350b362c92d/e3189/modal-example-intro.png",
            "srcSet": ["/version/4.2.0/static/63f781efbfdefd5014fd1350b362c92d/a2ead/modal-example-intro.png 259w", "/version/4.2.0/static/63f781efbfdefd5014fd1350b362c92d/6b9fd/modal-example-intro.png 518w", "/version/4.2.0/static/63f781efbfdefd5014fd1350b362c92d/e3189/modal-example-intro.png 1035w", "/version/4.2.0/static/63f781efbfdefd5014fd1350b362c92d/44d59/modal-example-intro.png 1553w", "/version/4.2.0/static/63f781efbfdefd5014fd1350b362c92d/913b9/modal-example-intro.png 1822w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span></p>
<hr></hr>
<h2>{`Usage`}</h2>
<p>{`A modal is intentionally interruptive and blocks the user from interacting with the on-page content. Modals keep the user focused on the task or information until they either cancel or complete the task. Modals can be very useful when used effectively but should be used sparingly to avoid disrupting the user too much. Here are some guidelines for when to use a modal.`}</p>
<h3>{`Confirm a User Decision`}</h3>
<p>{`Clearly describe the decision being made by the user, and explain any possible consequences it could cause. The primary button should also reinforce the action being taken. If the action being taken is irreversible, make that clear to the user as well. The user should also be able to cancel the action with a secondary button or closing the modal.`}</p>
<span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1035px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "52.123552123552116%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA6ElEQVQoz6XRMW+CQBTAcT8nDlw5+t4xMTKwQki66IREm6aTiUUmZwbpJ+iH6KDcQUKOXhzINW2iQVOtxv/2kvdb3hvAcbZtu64bx3GSJJN90+nM933LshCxvzzoD4hICImiqG1bKWXTNEqpruu01lmWGYbhOM4/OAiCqqo450IILgTnQmudpumVOKzruizLzWYrpVRf7Q04DMPuJ62U3pa74Onjdf65WCyHQ4Oxi5hS6nleURTvv+X5+vll9Zbmo9HYNE1EdhYfDm7uI4QgWI/2A6UUAE82/8AAwHoBMER28qRL+Mruwt9haCN5bnoPSgAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "confirm decision",
          "title": "confirm decision",
          "src": "/version/4.2.0/static/6c39c0ee5172425465149533af3cec6c/e3189/confirm-decision.png",
          "srcSet": ["/version/4.2.0/static/6c39c0ee5172425465149533af3cec6c/a2ead/confirm-decision.png 259w", "/version/4.2.0/static/6c39c0ee5172425465149533af3cec6c/6b9fd/confirm-decision.png 518w", "/version/4.2.0/static/6c39c0ee5172425465149533af3cec6c/e3189/confirm-decision.png 1035w", "/version/4.2.0/static/6c39c0ee5172425465149533af3cec6c/44d59/confirm-decision.png 1553w", "/version/4.2.0/static/6c39c0ee5172425465149533af3cec6c/913b9/confirm-decision.png 1822w"],
          "sizes": "(max-width: 1035px) 100vw, 1035px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
<h3>{`Edit or Manage Tasks`}</h3>
<p>{`It's very common to use a modal to quickly edit or manage one or more items on a page without going back and forth between multiple pages. The emphasis here is "quickly". If the settings or management of an item becomes relatively complex and requires many decisions or multiple steps, please consider using a separate page or something other than a modal. If a particular action is often done repeatedly, consider allowing the action to be done directly on the main page rather than in a modal.`}</p>
<span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1035px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "66.79536679536679%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAABX0lEQVQoz3WSvU7CUBiGuc4SFkJPf0iMgw7cAq4GpJOhhAsQTRwcjYODmxL638GBAQKl7WnP32dKlQC2z/7kfb83XwMhpChKu93u9XqGYQyHw7t6RiOj37+RZRntaSCENE2TJGk6nQLAZrPBGEMVQggA8P2g0+mcyM1m0zRNzvlqtcrznFfBGAMAx3GqZQBI05TWQAgBAMuyzmVJkiaTSVlb1FAmu65bmxzHMauBUgoAtm3Xypzzo4UqBquofZAJIftpCoTglFLGWLkWIXQ/2GmyqqqlTCmNoogQUpaMk3y320VRlGU5LWSCMzGfW7L8Tx6PxwCw3W4xxoSQPCfrdYxxliRJlqWMUSGKixaLRcXa5ZOUk55BaXHt0/P37ch9fZvrOip/7De51WoNBoPlcul5XvhHEARhGPp+8Pnl2LY3e/y4N98fZi+qciQfUGvQdU3T1MvL7vXVRVdXD7/9A/nxNVLDcbEbAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "edit item example",
          "title": "edit item example",
          "src": "/version/4.2.0/static/2d324380c92c0f80081e7052499783e5/e3189/edit-item-example.png",
          "srcSet": ["/version/4.2.0/static/2d324380c92c0f80081e7052499783e5/a2ead/edit-item-example.png 259w", "/version/4.2.0/static/2d324380c92c0f80081e7052499783e5/6b9fd/edit-item-example.png 518w", "/version/4.2.0/static/2d324380c92c0f80081e7052499783e5/e3189/edit-item-example.png 1035w", "/version/4.2.0/static/2d324380c92c0f80081e7052499783e5/44d59/edit-item-example.png 1553w", "/version/4.2.0/static/2d324380c92c0f80081e7052499783e5/913b9/edit-item-example.png 1822w"],
          "sizes": "(max-width: 1035px) 100vw, 1035px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
<hr></hr>
<h2>{`Sizes`}</h2>
<p>{`Modals come in three responsive sizes: small, medium, and large.`}</p>
<span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1035px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "63.70656370656371%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAABv0lEQVQoz2WSy27aQBSGeU/EZTy3M/ZYGI8ReFJUiYodG9SL+gYR3VWqopRFK3XRDcgCRxDL2bRSW/UF2NDQqWLD4DTfwrZ0/jPz/+e4xgo45+wxhJBGo1Gv1zHGT6sltfKFMSaE0ALOOcY4iqLZbHZ19eHiQjuOwzmnlJaa8vnQTCkFgF6vp5TqdrtBEFBKW63WeDy+vz8YY6bTabPZZIx1Op1SEMex53mU0uPNUkrP81zXFUIwxhBCWsdJsrp89zXWzx0HMcYBwHVdAJBSAsDZNikobVenUMiOgemJs+1SV0rtB6V0Pp8nSZKmN4vlQkpJCIECq3lo5pz3+/04jm2k0kWe54fDYf/n77fvv4Og4zhOEARhGCqltNZSymNme6R1ixC6vv54d5d9+rx48/a973uYECuw4prNU12gEKIYCRcCfOlyDrZUnUut2gMACKHhcLjdbpfLZZZleZ7f3ma/fv6YTCbtdrvq8dw8GAyiKFJKCSFGo5ExZrfb7fd7Y0yR3Lx89RqAK6XCMNRa+75/3jOcKDasN5vNarVar9dpmiZJcjn78mz4AmOHn6b9f2abhBDSfAwhiFLy9N/+B8HIbirnQiVkAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "modal sizes",
          "title": "modal sizes",
          "src": "/version/4.2.0/static/9e77a8de4ea35f266c1ab2e79c2912fb/e3189/modal-sizes.png",
          "srcSet": ["/version/4.2.0/static/9e77a8de4ea35f266c1ab2e79c2912fb/a2ead/modal-sizes.png 259w", "/version/4.2.0/static/9e77a8de4ea35f266c1ab2e79c2912fb/6b9fd/modal-sizes.png 518w", "/version/4.2.0/static/9e77a8de4ea35f266c1ab2e79c2912fb/e3189/modal-sizes.png 1035w", "/version/4.2.0/static/9e77a8de4ea35f266c1ab2e79c2912fb/c1b63/modal-sizes.png 1200w"],
          "sizes": "(max-width: 1035px) 100vw, 1035px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
<h3>{`Small`}</h3>
<p>{`The default width of the small modal is 300px. Works well for basic alerts and confirmations.`}</p>
<DemoModal size="small" mdxType="DemoModal" />
<h3>{`Medium`}</h3>
<p>{`The default width of the medium modal is 600px. Works well for standard single-column forms.`}</p>
<DemoModal size="medium" mdxType="DemoModal" />
<h3>{`Large`}</h3>
<p>{`The default width of the large modal is 900px. Works well for UI's requiring multi-column layouts. If you are considering the large modal, you should also be seriously considering using a new page instead.`}</p>
<DemoModal size="large" mdxType="DemoModal" />
<h3>{`Modal Height`}</h3>
<p>{`React Magma modals do not have a maximum height at this time. They are as tall as they need to be to fit the content, which means it's possible for the bottom of the modal to extend beyond the bottom of the viewport. You can still easily scroll the entire modal in order to access the content off-screen.`}</p>
<h3>{`Responsive Behavior`}</h3>
<p>{`When the viewport of the device is 600px wide or below, the padding within the modal decreases from 24px to 16px. This matches the change in gutter widths on the overall page layout on smaller devices. The result allows the content of the modal to maximize the available space.`}</p>
<hr></hr>
<h2>{`Behaviors`}</h2>
<h3>{`Trigger`}</h3>
<p>{`Modals are typically triggered by a user's action rather than generated by the system. Common components used to trigger a modal include buttons, links, and icons. A modal can also be opened using a keyboard by pressing `}<inlineCode parentName="p">{`Enter`}</inlineCode>{` or `}<inlineCode parentName="p">{`Space`}</inlineCode>{`.`}</p>
<h3>{`Closing`}</h3>
<p>{`Modals should always contain a way to close them, and there are typically multiple ways for any modal. The most obvious is the Close button in the upper-right corner. Less obvious, but always present, is the ability to press `}<inlineCode parentName="p">{`Escape`}</inlineCode>{` on the keyboard or simply click outside the modal. Additionally, there is often a primary action button that triggers a process and then closes the modal when it's completed or a Cancel button that closes the modal without taking any further action.`}</p>
<h3>{`Focus`}</h3>
<p>{`When a modal is opened, the focus is automatically put on the title of the modal rather than the first actionable element. We intentionally do this to provide an optimal experience for both people using assistive technologies and those who don't.`}</p>
<span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1035px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "40.54054054054054%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAIAAAB2/0i6AAAACXBIWXMAAAsTAAALEwEAmpwYAAABC0lEQVQY03WQ3WqDQBBG85x6ayTeeJVeGdNnEfGVQpMmKfTKXdfadfbP1d0pKEmh2MPH8DFwYJhNPLPdbtM0fT0ej3meHw6HLFtNlmX7/Uv8YBPH8W63C8OwKIqWw/vHJ/n6FnbqtQVtwSwZwViuB4d4Or1FUfQrJ0kSBEFVVZPzlLW8B6k0KCWUBiFBql4IqU0vpPP+fr//lcMwLMtyHEdKCGOsmSF1TUhNCCF13VDKGEPE6/W6LjvnOOfOOe/9cy5l6Yh4u93+ldu2BQCttZ0ZZ5Y+DAMiXi6XdRkRAcA/QERjzLJBxGmaVs5evl2WpbWWUso5V0oNM0KIpmm6rpNSGmO89+fz+Sn/AOOkXnHQbSujAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "modal focus example",
          "title": "modal focus example",
          "src": "/version/4.2.0/static/daa8fad529227faa05558e8b72e01a15/e3189/modal-focus-example.png",
          "srcSet": ["/version/4.2.0/static/daa8fad529227faa05558e8b72e01a15/a2ead/modal-focus-example.png 259w", "/version/4.2.0/static/daa8fad529227faa05558e8b72e01a15/6b9fd/modal-focus-example.png 518w", "/version/4.2.0/static/daa8fad529227faa05558e8b72e01a15/e3189/modal-focus-example.png 1035w", "/version/4.2.0/static/daa8fad529227faa05558e8b72e01a15/44d59/modal-focus-example.png 1553w", "/version/4.2.0/static/daa8fad529227faa05558e8b72e01a15/913b9/modal-focus-example.png 1822w"],
          "sizes": "(max-width: 1035px) 100vw, 1035px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
<h3>{`Validation`}</h3>
<p>{`Always validate a user's input entries before a modal is closed. If there are any errors, an inline error alert should be displayed above the form, as well as error messages on any specific inputs that failed validation. The error messages should provide clear instructions on how to resolve the errors and complete the action.`}</p>
<span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1035px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "66.40926640926641%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAABzUlEQVQoz3WSy2rbQBSG85yyV8aSJbwqlmm96GWdPoDj2oWAjNdZNH2CUroodNMWgm3SKIqDpZkzulnVaC6nKE6D7SQfP7MY+Jhzzpwjy7I6nU6r1RoMBuPxeDgcnjzPaPTh+Pi9aZrWHUeWZTmOYxjGbDZDRMYY5xyfQmuNiJeXf9rt9p7cMAzP86QQYRgCADAAxgCAUgqURoSwOKaUcs4Xi/kjudHwPE9IuV6v4U4CALIlikgUUUJixhBxuVzuy7ZtGMZ0OsWbgC8XcnVTXfvC9yv/SvhXYrVShChCRBRizOa/frb3erbtuuzpFPMsCYIKQCaJjGPJoD7TVOW5ynOZZSiqxcXF4cvbsjXn4e0qi5nkpa6q+3C+jSpL1PoZ+fQUYxBJLNNEJonabFAplLKOUqikllXd83x/YPbOwABACCGVUrpms9lQSkvOpVS8kog4P5T/l41aA0CapkVRcM7LsiyKIkuTPK9vtFaI+MRXPSyJlPJgNziv87dUZ5/8s/Pbr99+O7a1nff9y81mczKZlGVJCIEdCKFBEAZBeB2Eo4/fTyY/zj9/cZwd2bIs0zS73a7rur1H9N1ev+/2XffN65fv3r7q9V487PY/kFwwozv7cF4AAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "modal validation",
          "title": "modal validation",
          "src": "/version/4.2.0/static/6471e07bf77a7a84a5912b891b7a9c38/e3189/modal-validation.png",
          "srcSet": ["/version/4.2.0/static/6471e07bf77a7a84a5912b891b7a9c38/a2ead/modal-validation.png 259w", "/version/4.2.0/static/6471e07bf77a7a84a5912b891b7a9c38/6b9fd/modal-validation.png 518w", "/version/4.2.0/static/6471e07bf77a7a84a5912b891b7a9c38/e3189/modal-validation.png 1035w", "/version/4.2.0/static/6471e07bf77a7a84a5912b891b7a9c38/44d59/modal-validation.png 1553w", "/version/4.2.0/static/6471e07bf77a7a84a5912b891b7a9c38/913b9/modal-validation.png 1822w"],
          "sizes": "(max-width: 1035px) 100vw, 1035px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
</PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      